import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CustomBranding, SessionFacade } from '@shared/store/session.facade';
import { environment } from 'environments/environment';

@Component({
  selector: 'eop-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent implements OnInit {
  sessionFacade = inject(SessionFacade);

  readonly CustomBranding = CustomBranding;
  knowledgeBaseUrl: string;

  ngOnInit() {
    this.knowledgeBaseUrl = environment.knowledgeBaseUrl;
  }
  getCurrentYear(): string {
    return new Date().getFullYear().toString();
  }
}
